import React from "react";

function Copyright() {
  return (
    <section className="copyright bg-primary py-2">
      <h6 className="text-white font-thin text-center text-small">
        Designed and coded by Rizqy Fachri
      </h6>
    </section>
  );
}

export default Copyright;
